// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../services/api';

const homeService = async () => {
  const host = '/api/v2/pages/?type=home.HomePage';
  const params = [
    'title_line1',
    'title_line2',
    'video_block_title',
    'video_link',
    'rating_block_title',
    'rating_block_description',
    'rating_block_carousel_interval',
    'rating_panel(rating)',
    'gallery_image_picker(description)',
    'carbon_block_title',
    'carbon_block_description',
  ];

  return api(
    `${host}&fields=${params.toString()}`,
    {},
    'GET'
  );
};


export {
  homeService,
};
